import api from './api';
import store from '../store';
import { updateSubscription } from '../reducers/subscription';

export const calculateShipping = (zipcode, quantity) => {
  loadShipping(zipcode, quantity, (response) => {
    let data = response.data;

    if(data && data.id){
      store.dispatch(updateSubscription({
        shippingPrice: data.discounted_price,
        deliveryTime: data.delivery_time,
        itemsToFreeShipping: data.items_to_free_shipping
      }));
    }
  });
}

export const loadShipping = (zipcode, quantity, callback) => {
  api.get('/subscriptions/shipping', {
    params: {
      quantity: quantity,
      zipcode: zipcode
    }
  }).then((response) => {
    if(callback) callback(response);
  }).catch((response) => {
    if(callback) callback(response);
  });
}
